

import {
  BASE_URL,  // api/
  ADMIN_API, // api/admin
  CLIENT_API, // api/client
  CLIENT_APP_API, // api/app
  BASE_API         // api/base
} from "@/config";

export const apiConstants = {
  auth: `${CLIENT_API}/auth`, //api/client/auth
  authApp: `${CLIENT_APP_API}/auth`, // api/app/auth
  me : `${BASE_URL}/me`,
  userLogged : `${ADMIN_API}/auth/user`,
  client: `${CLIENT_API}/clients`,
  clientBase: `${BASE_API}/clients`,
  clientApp: `${CLIENT_APP_API}/clients`,
}
